import React, { useState, useRef, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const ChangePasswordModal = ({ showModal, handleClose }) => {
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [formData, setFormData] = useState({
        newPassword: 'demo1234',
        confirmPassword: 'demo1234',
    });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState({
        newPassword: false,
        confirmPassword: false,
    });


    const togglePasswordVisibility = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const otpRefs = useRef([]);

    const handleOtpChange = (index, value) => {
        if (/^\d?$/.test(value)) {
            const updatedOtp = [...otp];
            updatedOtp[index] = value;
            setOtp(updatedOtp);

            if (value && index < 5) {
                otpRefs.current[index + 1]?.focus();
            }
        }
    };

    const validatePasswords = () => {
        const errs = {};
        if (!formData.newPassword) errs.newPassword = 'New password is required.';
        if (!formData.confirmPassword) errs.confirmPassword = 'Confirm password is required.';
        if (formData.newPassword !== formData.confirmPassword)
            errs.confirmPassword = 'Passwords do not match.';
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const resetForm = () => {
        setStep(1);
        setFormData({ newPassword: '', confirmPassword: '' });
        setOtp(Array(6).fill(''));
        setErrors({});
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (step === 1) {
            if (!validatePasswords()) return;
            setStep(2);
            setTimeout(() => otpRefs.current[0]?.focus(), 100);
        } else {
            if (otp.join('').length !== 6) {
                return;
            }


            // Delay close/reset slightly to avoid unmounting ToastContainer too early
            setTimeout(() => {
                handleClose();
                resetForm();
            }, 300);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                closeOnClick
                pauseOnHover
                draggable
            />

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{step === 1 ? 'Change Password' : 'Verify your Email'}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        {step === 1 ? (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label>New Password</Form.Label>
                                    <div style={{ position: 'relative' }}>
                                        <Form.Control
                                            type={showPassword.newPassword ? 'text' : 'password'}
                                            name="newPassword"
                                            placeholder="New Password"
                                            value={formData.newPassword}
                                            onChange={(e) =>
                                                setFormData({ ...formData, newPassword: e.target.value })
                                            }
                                            isInvalid={!!errors.newPassword}
                                        />
                                        <div
                                            onClick={() => togglePasswordVisibility('newPassword')}
                                            className="eye-icon"
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '12px',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                color: '#666',
                                            }}
                                        >
                                            {showPassword.newPassword ? <FaEyeSlash /> : <FaEye />}
                                        </div>

                                    </div>
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.newPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <div style={{ position: 'relative' }}>
                                        <Form.Control
                                            type={showPassword.confirmPassword ? 'text' : 'password'}
                                            name="confirmPassword"
                                            placeholder="Confirm Password"
                                            value={formData.confirmPassword}
                                            onChange={(e) =>
                                                setFormData({ ...formData, confirmPassword: e.target.value })
                                            }
                                            isInvalid={!!errors.confirmPassword}
                                        />
                                        <div
                                            onClick={() => togglePasswordVisibility('confirmPassword')}
                                            className="eye-icon"
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '12px',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                color: '#666',
                                            }}
                                        >
                                            {showPassword.confirmPassword ? <FaEyeSlash /> : <FaEye />}
                                        </div>

                                    </div>
                                    <Form.Control.Feedback type="invalid" className="d-block">
                                        {errors.confirmPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </>

                        ) : (
                            <Form.Group className="mb-3">
                                <p className="text-center mb-3">
                                    We have sent you a 6-digit code on your registered email address
                                </p>
                                <Row className="mb-3 d-flex justify-content-between otp-form-input-wraper">
                                    {otp.map((digit, index) => (
                                        <Col key={index} xs={2} className='otp-form-input'>
                                            <Form.Control
                                                type="text"
                                                maxLength="1"
                                                value={digit}
                                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                                ref={(ref) => (otpRefs.current[index] = ref)}
                                                className="text-center"
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                <div className="text-center">
                                    <Button variant="link" className="text-link p-0" onClick={() => toast.info('Code resent!')}>
                                        Resend Code
                                    </Button>
                                </div>
                            </Form.Group>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit"  >
                            {step === 1 ? 'Set Password' : 'Verify'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default ChangePasswordModal;
